import gsap from "gsap";

export default class Header {
	constructor() {
		this.header = document.querySelector("[js-header]");
		this.hamburger = document.querySelector("[js-hamburger]");
		this.nav = document.querySelector("[js-nav]");
		this.overlay = document.querySelector("[js-overlay]");
		this.init();
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.hamburger.addEventListener("click", () => this.toggleNavHandler());
	}

	toggleNavHandler() {
		const isOpen = this.hamburger.getAttribute("aria-expanded") === "true";

		if (isOpen) {
			this.closeNav();
		} else {
			this.openNav();
		}
	}

	openNav() {
		this.hamburger.setAttribute("aria-expanded", true);
		gsap.set(this.overlay, { display: "block" });
		gsap.to(this.nav, { xPercent: -100, duration: 0.5, ease: "power3.out" });
		gsap.to(this.overlay, { opacity: 1, duration: 0.5, ease: "power3.out" });
	}

	closeNav() {
		this.hamburger.setAttribute("aria-expanded", false);
		gsap.to(this.nav, { xPercent: 0, duration: 0.5, ease: "power3.out" });
		gsap.to(this.overlay, { opacity: 0, duration: 0.5, ease: "power3.out" });
		gsap.set(this.overlay, { display: "none", delay: 0.51 });
	}
}
